if (!customElements.get('product-favourite')) {
  customElements.define('product-favourite', class ProductFavourite extends BaseElement
  {
    constructor ()
    {
      super();

      this.productCard = this.closest('product-card');
      this.donorCard = this.closest('.donor-card');
      this.update();

      this.addEventListener('click', e => {
        if (this.classList.contains('logged-out') || this.classList.contains('loading')) {
          return false;
        }

        e.preventDefault();

        this.toggle();
      });

      this.onBroadcast('wishlist', () => {
        this.update();
      });

      this.onBroadcast('wishlistLoadingStart', id => {
        if (id == this.getId()) {
          this.classList.add('loading');
        }
      });

      this.onBroadcast('wishlistLoadingEnd', id => {
        if (id == this.getId()) {
          this.classList.remove('loading');
        }
      });
    }

    update ()
    {
      if (this.classList.contains('loading')) {
        return;
      }

      if (this.isFavourite()) {
        this.classList.remove('off');
        this.classList.add('on');
      } else {
        this.classList.remove('on');
        this.classList.add('off');
      }
    }

    toggle ()
    {
      if (this.isFavourite()) {
        this.unfav();
      } else {
        this.fav();
      }
    }

    async fav ()
    {
      this.classList.remove('on', 'off');

      broadcast('wishlistLoadingStart', this.getId());

      try {
        const response = await fetch('https://app.donornetwork.com/api/shopify/customer/curation', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...app.apiHeaders()
          },
          body: JSON.stringify({
            product_id: 'gid://shopify/Product/' + this.getId(),
            action: 'add',
            type: 'favorite'
          })
        });

        const data = await response.json();

        if (data.data) {
          // Update cache with full curations response
          app.cache.put(window.cacheKeys.customerCurations, data.data, 86400);

          // Update customer curations data in memory
          if (app.customer.curationsData) {
            app.customer.curationsData = data.data;
          }

          broadcast('wishlisted', {
            product_id: 'gid://shopify/Product/' + this.getId()
          });
        } else {
          console.error('Failed to add favorite:', data);
        }
      } catch (error) {
        console.error('Error adding favorite:', error);
      } finally {
        broadcast('wishlistLoadingEnd', this.getId());

        // Always broadcast wishlist event and update after loading ends
        broadcast('wishlist');

        // Use setTimeout to ensure loading class is removed before update
        setTimeout(() => {
          this.update();
        }, 10);
      }
    }

    async unfav ()
    {
      this.classList.remove('on', 'off');

      broadcast('wishlistLoadingStart', this.getId());

      try {
        const response = await fetch('https://app.donornetwork.com/api/shopify/customer/curation', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...app.apiHeaders()
          },
          body: JSON.stringify({
            product_id: 'gid://shopify/Product/' + this.getId(),
            action: 'remove',
            type: 'favorite'
          })
        });

        const data = await response.json();

        if (data.data) {
          // Update cache with full curations response
          app.cache.put(window.cacheKeys.customerCurations, data.data, 86400);

          // Update customer curations data in memory
          if (app.customer.curationsData) {
            app.customer.curationsData = data.data;
          }
        } else {
          console.error('Failed to remove favorite:', data);
        }
      } catch (error) {
        console.error('Error removing favorite:', error);
      } finally {
        broadcast('wishlistLoadingEnd', this.getId());

        // Always broadcast wishlist event and update after loading ends
        broadcast('wishlist');

        // Use setTimeout to ensure loading class is removed before update
        setTimeout(() => {
          this.update();
        }, 10);
      }
    }

    getId ()
    {
      if (typeof(this.dataset.productId) !== 'undefined') {
        return this.dataset.productId;
      }

      if (this.productCard) {
        return typeof(this.productCard.dataset.productCardId) !== 'undefined'
          ? this.productCard.dataset.productCardId
          : null;
      }

      if (this.donorCard) {
        return typeof(this.donorCard.dataset.productId) !== 'undefined'
          ? this.donorCard.dataset.productId
          : null;
      }

      return null;
    }

    getHandle ()
    {
      if (typeof(this.dataset.productHandle) !== 'undefined') {
        return this.dataset.productHandle;
      }

      const productCard = this.closest('product-card');

      if (!productCard) {
        return null;
      }

      return typeof(productCard.dataset.productCardHandle) !== 'undefined'
        ? productCard.dataset.productCardHandle
        : null;
    }

    isFavourite ()
    {
      const favouriteProducts = app.cache.get(window.cacheKeys.customerCurations);

      if (!favouriteProducts) {
        return false;
      }

      let favourite = false;
      const currentProductId = "gid://shopify/Product/" + this.getId();

      favouriteProducts.forEach(product => {
        if (product.type !== 'favorite') {
          return;
        }
        if (product.product_id == currentProductId) {
          favourite = true;
        }
      });

      return favourite;
    }
  });
}